"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MassCoupon = void 0;
var irt_1 = require("@playq/irt");
var AbstractCouponData_1 = require("./AbstractCouponData");
var MassCouponData_1 = require("./MassCouponData");
var ItemUnit_1 = require("./ItemUnit");
var CouponID_1 = require("./CouponID");
var IdentifiedCoupon_1 = require("./IdentifiedCoupon");
var MassCoupon = (function () {
    function MassCoupon(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            this.goods = [];
            return;
        }
        this.validFromAsString = typeof data.validFrom !== 'undefined' ? data.validFrom : undefined;
        this.validTillAsString = typeof data.validTill !== 'undefined' ? data.validTill : undefined;
        this.name = data.name;
        this.message = typeof data.message !== 'undefined' ? data.message : undefined;
        this.claims = data.claims;
        this.goods = data.goods.map(function (e) { return new ItemUnit_1.ItemUnit(e); });
        this.disabled = data.disabled;
        this.code = data.code;
        this.limit = typeof data.limit !== 'undefined' ? data.limit : undefined;
        this.id = new CouponID_1.CouponID(data.id);
    }
    MassCoupon.prototype.getPackageName = function () { return MassCoupon.PackageName; };
    MassCoupon.prototype.getClassName = function () { return MassCoupon.ClassName; };
    MassCoupon.prototype.getFullClassName = function () { return MassCoupon.FullClassName; };
    Object.defineProperty(MassCoupon.prototype, "validFrom", {
        get: function () {
            return this._validFrom;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._validFrom = undefined;
                return;
            }
            if (!(value instanceof Date)) {
                throw new Error('Field validFrom expects type Date, got ' + value);
            }
            this._validFrom = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MassCoupon.prototype, "validFromAsString", {
        get: function () {
            if (!this._validFrom) {
                return undefined;
            }
            return irt_1.Formatter.writeZoneDateTime(this._validFrom);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                this._validFrom = undefined;
                return;
            }
            this._validFrom = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MassCoupon.prototype, "validTill", {
        get: function () {
            return this._validTill;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._validTill = undefined;
                return;
            }
            if (!(value instanceof Date)) {
                throw new Error('Field validTill expects type Date, got ' + value);
            }
            this._validTill = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MassCoupon.prototype, "validTillAsString", {
        get: function () {
            if (!this._validTill) {
                return undefined;
            }
            return irt_1.Formatter.writeZoneDateTime(this._validTill);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                this._validTill = undefined;
                return;
            }
            this._validTill = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MassCoupon.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MassCoupon.prototype, "message", {
        get: function () {
            return this._message;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._message = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field message expects type string, got ' + value);
            }
            this._message = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MassCoupon.prototype, "claims", {
        get: function () {
            return this._claims;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field claims is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field claims expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field claims is expected to be an integer, got ' + value);
            }
            this._claims = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MassCoupon.prototype, "goods", {
        get: function () {
            return this._goods;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field goods is not optional');
            }
            this._goods = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MassCoupon.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field disabled is not optional');
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field disabled expects boolean type, got ' + value);
            }
            this._disabled = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MassCoupon.prototype, "code", {
        get: function () {
            return this._code;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field code is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field code expects type string, got ' + value);
            }
            this._code = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MassCoupon.prototype, "limit", {
        get: function () {
            return this._limit;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._limit = undefined;
                return;
            }
            if (typeof value !== 'number') {
                throw new Error('Field limit expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field limit is expected to be an integer, got ' + value);
            }
            this._limit = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MassCoupon.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    MassCoupon.prototype.toMassCouponDataSerialized = function () {
        return {
            validFrom: typeof this.validFrom !== 'undefined' ? this.validFromAsString : undefined,
            validTill: typeof this.validTill !== 'undefined' ? this.validTillAsString : undefined,
            name: this.name,
            message: typeof this.message !== 'undefined' ? this.message : undefined,
            claims: this.claims,
            goods: this.goods.map(function (e) { return e.serialize(); }),
            disabled: this.disabled,
            code: this.code,
            limit: typeof this.limit !== 'undefined' ? this.limit : undefined
        };
    };
    MassCoupon.prototype.toMassCouponData = function () {
        return new MassCouponData_1.MassCouponDataStruct(this.toMassCouponDataSerialized());
    };
    MassCoupon.prototype.toAbstractCouponDataSerialized = function () {
        return {
            validFrom: typeof this.validFrom !== 'undefined' ? this.validFromAsString : undefined,
            validTill: typeof this.validTill !== 'undefined' ? this.validTillAsString : undefined,
            name: this.name,
            message: typeof this.message !== 'undefined' ? this.message : undefined,
            claims: this.claims,
            goods: this.goods.map(function (e) { return e.serialize(); }),
            disabled: this.disabled,
            code: this.code
        };
    };
    MassCoupon.prototype.toAbstractCouponData = function () {
        return new AbstractCouponData_1.AbstractCouponDataStruct(this.toAbstractCouponDataSerialized());
    };
    MassCoupon.prototype.toIdentifiedCouponSerialized = function () {
        return {
            id: this.id.serialize()
        };
    };
    MassCoupon.prototype.toIdentifiedCoupon = function () {
        return new IdentifiedCoupon_1.IdentifiedCouponStruct(this.toIdentifiedCouponSerialized());
    };
    MassCoupon.prototype.loadMassCouponDataSerialized = function (slice) {
        this.validFromAsString = typeof slice.validFrom !== 'undefined' ? slice.validFrom : undefined;
        this.validTillAsString = typeof slice.validTill !== 'undefined' ? slice.validTill : undefined;
        this.name = slice.name;
        this.message = typeof slice.message !== 'undefined' ? slice.message : undefined;
        this.claims = slice.claims;
        this.goods = slice.goods.map(function (e) { return new ItemUnit_1.ItemUnit(e); });
        this.disabled = slice.disabled;
        this.code = slice.code;
        this.limit = typeof slice.limit !== 'undefined' ? slice.limit : undefined;
    };
    MassCoupon.prototype.loadMassCouponData = function (slice) {
        this.loadMassCouponDataSerialized(slice.serialize());
    };
    MassCoupon.prototype.loadAbstractCouponDataSerialized = function (slice) {
        this.validFromAsString = typeof slice.validFrom !== 'undefined' ? slice.validFrom : undefined;
        this.validTillAsString = typeof slice.validTill !== 'undefined' ? slice.validTill : undefined;
        this.name = slice.name;
        this.message = typeof slice.message !== 'undefined' ? slice.message : undefined;
        this.claims = slice.claims;
        this.goods = slice.goods.map(function (e) { return new ItemUnit_1.ItemUnit(e); });
        this.disabled = slice.disabled;
        this.code = slice.code;
    };
    MassCoupon.prototype.loadAbstractCouponData = function (slice) {
        this.loadAbstractCouponDataSerialized(slice.serialize());
    };
    MassCoupon.prototype.loadIdentifiedCouponSerialized = function (slice) {
        this.id = new CouponID_1.CouponID(slice.id);
    };
    MassCoupon.prototype.loadIdentifiedCoupon = function (slice) {
        this.loadIdentifiedCouponSerialized(slice.serialize());
    };
    MassCoupon.prototype.serialize = function () {
        return {
            validFrom: typeof this.validFrom !== 'undefined' ? this.validFromAsString : undefined,
            validTill: typeof this.validTill !== 'undefined' ? this.validTillAsString : undefined,
            name: this.name,
            message: typeof this.message !== 'undefined' ? this.message : undefined,
            claims: this.claims,
            goods: this.goods.map(function (e) { return e.serialize(); }),
            disabled: this.disabled,
            code: this.code,
            limit: typeof this.limit !== 'undefined' ? this.limit : undefined,
            id: this.id.serialize()
        };
    };
    MassCoupon.PackageName = 'net.playq.services.bookkeeper';
    MassCoupon.ClassName = 'MassCoupon';
    MassCoupon.FullClassName = 'net.playq.services.bookkeeper.MassCoupon';
    return MassCoupon;
}());
exports.MassCoupon = MassCoupon;
MassCouponData_1.MassCouponDataStruct.register(MassCoupon.FullClassName, MassCoupon);
AbstractCouponData_1.AbstractCouponDataStruct.register(MassCoupon.FullClassName, MassCoupon);
IdentifiedCoupon_1.IdentifiedCouponStruct.register(MassCoupon.FullClassName, MassCoupon);
var irt_2 = require("@playq/irt");
irt_2.Introspector.register(MassCoupon.FullClassName, {
    full: MassCoupon.FullClassName,
    short: MassCoupon.ClassName,
    package: MassCoupon.PackageName,
    type: irt_2.IntrospectorTypes.Data,
    ctor: function () { return new MassCoupon(); },
    fields: [
        {
            name: 'validFrom',
            accessName: 'validFrom',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Tsz } }
        },
        {
            name: 'validTill',
            accessName: 'validTill',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Tsz } }
        },
        {
            name: 'name',
            accessName: 'name',
            type: { intro: irt_2.IntrospectorTypes.Str }
        },
        {
            name: 'message',
            accessName: 'message',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Str } }
        },
        {
            name: 'claims',
            accessName: 'claims',
            type: { intro: irt_2.IntrospectorTypes.I64 }
        },
        {
            name: 'goods',
            accessName: 'goods',
            type: { intro: irt_2.IntrospectorTypes.List, value: { intro: irt_2.IntrospectorTypes.Data, full: 'net.playq.services.bookkeeper.ItemUnit' } }
        },
        {
            name: 'disabled',
            accessName: 'disabled',
            type: { intro: irt_2.IntrospectorTypes.Bool }
        },
        {
            name: 'code',
            accessName: 'code',
            type: { intro: irt_2.IntrospectorTypes.Str }
        },
        {
            name: 'limit',
            accessName: 'limit',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.I64 } }
        },
        {
            name: 'id',
            accessName: 'id',
            type: { intro: irt_2.IntrospectorTypes.Id, full: 'net.playq.services.bookkeeper.CouponID' }
        }
    ]
});
//# sourceMappingURL=MassCoupon.js.map